import {Flex, Image} from "antd";
import {Fade} from "react-awesome-reveal";
import img27 from "../../About/images/27.jpg";
import MyText from "../../../components/UI/Text/MyText";
import {clrs} from "../../../constants/colors";
import HorizontalDivider from "../../../components/Divider/HorizontalDivider";
import {Link} from "react-router-dom";
import {LinkOutlined} from "@ant-design/icons";
import React from "react";

export const Person27 = () => {
    return (
        <Flex style={{width: "100%", position: "relative"}} vertical gap={20}>
            <Flex style={{width: "100%", position: "relative"}} gap={40}>
                <Fade triggerOnce={true} cascade damping={0.15}>
                    <Image src={img27} width={300} preview={false} style={{borderRadius: 20}}/>
                </Fade>

                <Flex style={{width: "100%", position: "relative"}} vertical>
                    <MyText strong size={"large"}>
                        Аубакирова Алия Муратовна
                    </MyText>
                    <MyText style={{color: clrs.whiterBlacker}}>
                        Master of Engineering Science in Information Systems, Doctorate PhD Student of Computer Science
                    </MyText>
                    <br/>
                    <HorizontalDivider/>
                    <br/>
                    <Flex gap={20} wrap={"wrap"} vertical>
                        <Link target={"_blank"} to={'https://www.scopus.com/authid/detail.uri?authorId=58861077700'}>
                            <MyText><LinkOutlined /> Scopus</MyText>
                        </Link>
                        <Link target={"_blank"} to={'https://orcid.org/0009-0004-6925-6714'}>
                            <MyText><LinkOutlined /> Orcid</MyText>
                        </Link>
                    </Flex>
                    <br/>
                    <MyText strong size={"small"}>Основное место работы, должность</MyText>
                    <MyText>
                        ТОО "Astana IT University", младший научный сотрудник, НИЦ "Industry 4.0"
                    </MyText>
                </Flex>
            </Flex>

            <Flex style={{width: "100%", position: "relative"}} vertical>
                <MyText strong size={"small"}>
                    Роль в проекте или программе, а также характер выполняемой работы
                </MyText>
                <MyText size={"small"} italic>
                    Разработчик информационных систем
                </MyText>
                <MyText size={"small"} style={{paddingLeft: 20}}>
                    - Совместное проведение экспериментальных исследований;
                </MyText>
                <MyText size={"small"} style={{paddingLeft: 20}}>
                    - Написание научных статей;
                </MyText>
                <MyText size={"small"} style={{paddingLeft: 20}}>
                    - Разработка интеллектуальной системы в части применения методов больших данных и машинного обучения;
                </MyText>
            </Flex>

            <Flex style={{width: "100%", position: "relative"}} vertical>
                <MyText strong size={"small"}>Краткое обоснование участия</MyText>
                <MyText size={"small"} style={{paddingLeft: 20}}>
                    Магистр 6M070300 «Информационные системы». Докторант по специальности 8D06101 «Computer Science».
                    Знания в области HTML, CSS, AutoCAD, 3DsMAX. Опыт преподавания и участия в проектировании и разработке информационных систем.
                </MyText>
            </Flex>

            <Flex style={{width: "100%", position: "relative"}} vertical>
                <MyText strong size={"small"}>Научные проекты, в которых принимала участие:</MyText>
                <MyText size={"small"} style={{paddingLeft: 20}}>
                    - ИРН AP19678773 «Разработка технологии интеллектуальной предварительной обработки аэрокосмических изображений для распознавания и идентификации различных объектов». Руководитель: Саринова А.Ж. Роль –исполнитель.
                </MyText>
                <MyText size={"small"} style={{paddingLeft: 20}}>
                    - ИРН AP19678730 «Разработка информационной технологии точного земледелия для управления сельскохозяйственной деятельностью с применением технологии «Internet of Things». Руководитель: Нефтисов А.В. Роль –исполнитель.
                </MyText>
                <MyText size={"small"} style={{paddingLeft: 20}}>
                    - ИРН BR24993128 «Разработка информационно-аналитической системы для принятия решений для эффективного использования трансграничных водных ресурсов в сельскохозяйственной отрасли Жамбылского региона». Руководитель: Нефтисов А.В. Роль –исполнитель.
                </MyText>
                <MyText size={"small"} style={{paddingLeft: 20}}>
                    - ИРН BR21882258 «Разработка комплекса интеллектуальных информационно-коммуникационных систем для экологического мониторинга эмиссий в окружающую среду для принятия решения в концепте углеродной нейтральности». Руководитель: Белощицкий А.А. Роль –исполнитель.
                </MyText>
            </Flex>

            <Flex style={{width: "100%", position: "relative"}} vertical>
                <MyText strong size={"small"}>Роль в достижении результатов проекта:</MyText>
                <MyText size={"small"} style={{paddingLeft: 20}}>
                    - Совместное проведение экспериментальных исследований;
                </MyText>
                <MyText size={"small"} style={{paddingLeft: 20}}>
                    - Написание научных статей;
                </MyText>
                <MyText size={"small"} style={{paddingLeft: 20}}>
                    - Разработка интеллектуальной системы в части применения методов больших данных и машинного обучения.
                </MyText>
            </Flex>

            <Flex style={{width: "100%", position: "relative"}} vertical>
                <MyText strong size={"small"}>Публикации по теме проекта:</MyText>
                <MyText size={"small"} style={{paddingLeft: 20}}>
                    1. Neftissov, A., Kazambayev, I., Kirichenko, L., Aubakirova, A., et al. Development of microprocessor device of relay protection based on open architecture using Industrial Internet of Things technology. Procedia Computer Science, 2024, 231, 672–677. DOI: https://doi.org/10.1016/j.procs.2023.12.163 (Процентиль – 68).
                </MyText>
            </Flex>
        </Flex>
    );
}